import * as React from "react";
import { useNavigate } from "react-router-dom";
import { image_ip } from "../../services/constants";
import { test_ip } from "../../services/constants";
import alt_back from "../../zmall.png";
import courier_img from "../../courier.png";
import { BorderColor } from "@mui/icons-material";

export default function ServiceCard(props) {
  // Determine the background image
  var background = props.service.image_url
    ? `${test_ip}${props.service.image_url}`
    : alt_back;
  console.log("props ");
  console.log(background);
  // var background = courier_img;

  const nav = useNavigate();
  const data = props.service;

  // Truncate the description if it's too long
  var string = data.description;
  if (string.length > 30) {
    string = string.substring(0, 29) + "...";
  }

  // Click handler
  const handleClick = React.useCallback(
    (id) => () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      nav(`/courier/${id}`, {
        state: { name: data.service_name }, // Assuming the service has a name
      });
    },
    [data, nav]
  );

  // Styles
  const container_style = {
    margin: "8px",
    backgroundImage: `url(${background})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "100% 100%",
    borderRadius: "50px",
    width: 320,
    height: 200,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end", // Align children to the bottom
    alignItems: "center",
    border: "2px solid red",
  };

  const card_style = {
    borderRadius: "50%", // Make it circular like DeliveryCard
    display: "flex",
    width: "100px",
    height: "100px",
    justifyContent: "center",
    alignItems: "end",
    marginBottom: "2px", // Add space between the card and the text
  };

  const text_style = {
    background: "white",
    textAlign: "center",
    padding: "4px",
    marginBottom: "5px",
    borderRadius: "10px",
    width: "75%",
    fontSize: "0.6rem",
  };

  return (
    <div style={container_style} onClick={handleClick(data._id)}>
      <div style={card_style}>
        {/* <div style={text_style}>{data.delivery_name}</div>{" "} */}
      </div>
    </div>
  );
}
